/**
Copyright (c) 2023, 2024, 2025 Amica Corp.
All rights reserved.

This source code, resulting binary forms, and associated documentation
(the "Software") may only be used, modified, or distributed, with or
without modification, under the terms of a written license agreement
with Amica Corp. (the "License"). All rights to manufacture, use,
redistribute, or sell anything described herein, in whole or in part,
are granted only as explicitly permitted by such License. The receipt
or possession of the Software does not convey any of these rights.

This Software is provided "AS IS," WITHOUT WARRANTY OF ANY KIND, express
or implied, including but not limited to the implied warranties of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.

For additional terms, see https://amica.cloud/software-copyright/
 */

/**
 * Define all the .env file related keys
 */
// eslint-disable-next-line prefer-destructuring
const env = import.meta.env;

const ENVIRONMENT = {
  BACKEND_API: env.REACT_APP_BACKEND_API,
  APP_NAME: env.REACT_APP_APP_NAME,
  APP_VERSION: env.REACT_APP_VERSION,
  PERSIST_ENCRYPTED_SECRET_KEY: env.REACT_APP_PERSIST_ENCRYPTED_SECRET_KEY,
  PERSIST_KEY: env.REACT_APP_PERSIST_KEY,
  PERSIST_VERSION: env.REACT_APP_PERSIST_VERSION,
  PBI_BASIC_SCHEMA: env.REACT_APP_PBI_BASIC_SCHEMA,
  PBI_ADVANCED_SCHEMA: env.REACT_APP_PBI_ADVANCED_SCHEMA,
  APP_LOGO: env.REACT_APP_LOGO,
  AIRO_APP_LOGO: env.REACT_APP_AIRO_LOGO,
  APP_LOGO_LIGHT: env.REACT_APP_LOGO_LIGHT,
  APP_FAVICON: env.REACT_APP_FAVICON,
  AIRO_FAVICON: env.REACT_APP_AIRO_FAVICON,
  APP_URL: env.REACT_APP_URL,
  AIRO_APP_URL: env.REACT_APP_AIRO_URL,
  CHAT_ENABLED: env.REACT_APP_CHAT_ENABLED,
  TIMEOUT_DELAY: env.REACT_APP_TIMEOUT_DELAY,
  REQUEST_TIMEOUT_MS: parseInt(env.REACT_APP_REQUEST_TIMEOUT_MS, 10) || 0,
  ENABLE_BULK_UPLOAD: env.REACT_APP_ENABLE_BULK_UPLOAD,
  ALLOW_EXTENDED_FORECASTS: env.REACT_APP_ALLOW_EXTENDED_FORECASTS,
  KC_DOMAIN: env.REACT_APP_KC_DOMAIN,
  KC_REALM: env.REACT_APP_KC_REALM,
  KC_CLIENT_ID: env.REACT_APP_CLIENT_ID,
  KC_AIRO_CLIENT_ID: env.REACT_APP_AIRO_CLIENT_ID,
  KC_PKCE_CHALLENGE_METHOD: env.REACT_APP_KC_PKCE_CHALLENGE_METHOD,
  KC_PKCE_VERIFIER_LENGTH: parseInt(env.REACT_APP_KC_PKCE_VERIFIER_LENGTH || '0', 10),
  PBI_EMBED_DEBUG_MODE: env.REACT_APP_PBI_EMBED_DEBUG_MODE,
  CHAT_DEBUG_MODE: env.REACT_APP_CHAT_DEBUG_MODE,
  AZURE_CDN_URL: env.REACT_APP_AZURE_CDN_URL,
  FARO_URL: env.REACT_APP_FARO_URL,
  FARO_ENV: env.REACT_APP_FARO_ENV,
  ENABLE_FARO: env.REACT_APP_ENABLE_FARO,
  FARO_APP_NAME: env.REACT_APP_FARO_APP_NAME,
  FARO_APP_VERSION: env.REACT_APP_FARO_APP_VERSION,
  FARO_NAMESPACE: env.REACT_APP_FARO_NAMESPACE,
  USER_MANUAL_URL: env.REACT_APP_USER_MANUAL_URL,
  SUPPORT_LINK: env.REACT_APP_SUPPORT_LINK,
  USER_MANUAL_PDF_URL: env.REACT_APP_USER_MANUAL_PDF_URL,
  FAQ_PDF_URL: env.REACT_APP_FAQ_PDF_URL,
  ENABLE_PBI_VISUAL_RENDERED_EVENT: env.REACT_APP_ENABLE_PBI_VISUAL_RENDERED_EVENT,
  CERULEAN_TABULAR_DEBUG_MODE: env.REACT_APP_CERULEAN_TABULAR_DEBUG_MODE,
  AUDIT_EXCEL_CONTAINER: env.REACT_APP_AUDIT_EXCEL_CONTAINER,
  AZURE_STORAGE_ACCOUNT: env.REACT_APP_AZURE_STORAGE_ACCOUNT,
  IS_VISUAL_INTERPRETER_ENABLED: env.REACT_APP_IS_VISUAL_INTERPRETER_ENABLED,
  GPT_INPUT_TOKEN_THRESHOLD: env.REACT_APP_GPT_INPUT_TOKEN_THRESHOLD,
  GPT_OUTPUT_TOKEN_THRESHOLD: env.REACT_APP_GPT_OUTPUT_TOKEN_THRESHOLD,
  IS_DATA_EXPORT_INTERPRETER_ENABLED: env.REACT_APP_IS_DATA_EXPORT_INTERPRETER_ENABLED,
  AGENT_INPUT_TOKEN_THRESHOLD: env.REACT_APP_AGENT_INPUT_TOKEN_THRESHOLD,
  AGENT_OUTPUT_TOKEN_THRESHOLD: env.REACT_APP_AGENT_OUTPUT_TOKEN_THRESHOLD,
  ENABLE_TREND_TABULAR_TAB: env.REACT_APP_ENABLE_TREND_TABULAR_TAB,
  ENABLE_PBI_TEST_TAB: env.REACT_APP_ENABLE_PBI_TEST_TAB,
  ENABLE_SEARCH_TAB: env.REACT_APP_ENABLE_SEARCH_TAB,
  ENABLE_VI_SHARE_FEATURE: env.REACT_APP_ENABLE_VI_SHARE_FEATURE,
  ENABLE_VI_SEARCH_FEATURE: env.REACT_APP_ENABLE_VI_SEARCH_FEATURE,
  ENABLE_TREND_SEGMENT_JS_TABLES: env.REACT_APP_ENABLE_TREND_SEGMENT_JS_TABLES,
  ENABLE_PACE_TIME_JS_TABLES: env.REACT_APP_ENABLE_PACE_TIME_JS_TABLES,
  ENABLE_PACE_HOTEL_JS_TABLES: env.REACT_APP_ENABLE_PACE_HOTEL_JS_TABLES,
  ENABLE_PACE_SEGMENT_JS_TABLES: env.REACT_APP_ENABLE_PACE_SEGMENT_JS_TABLES,
  ENABLE_PACE_TIME_SEGMENT_JS_TABLES: env.REACT_APP_ENABLE_PACE_TIME_SEGMENT_JS_TABLES,
  ENABLE_PACE_HOTEL_SEGMENT_JS_TABLES: env.REACT_APP_ENABLE_PACE_HOTEL_SEGMENT_JS_TABLES,
  ENABLE_TIME_SEGMENT_JS_TABLES: env.REACT_APP_ENABLE_TIME_SEGMENT_JS_TABLES,
  ENABLE_HOTEL_SEGMENT_JS_TABLES: env.REACT_APP_ENABLE_HOTEL_SEGMENT_JS_TABLES,
  ENABLE_FARO_TRACING: env.REACT_APP_ENABLE_FARO_TRACING,
};
//
export default ENVIRONMENT;
